import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { Group, Option } from './checkout.reducer';

@Component({
  selector: 'group-box-component',
  templateUrl: './group-box.component.html',
  styleUrls: ['../../assets/sass/checkout/group-box.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupBoxComponent implements OnInit {
  @Input()
  group: Group;

  ngOnInit() {
    this.group.subgroups.forEach(subgroup => {
      subgroup.options.forEach((option, index) => {
        if (subgroup.type === 'radio' && option.checked) {
          this.onRadioChange(option, subgroup);
        }
        if (option.min && option.max && option.type === 'range') {
          this.changeQuantity({ target: { value: option.selectedValue } }, option);
        }
        if (option.type === 'select') {
          this.changeQuantitySelect({ target: { value: option.selectedValue } }, option);
        }
      });
    });
  }

  // TODO - changes to store should be done via action store.dispatch - this solution is incorrect
  onRadioChange(option, subgroup) {
    subgroup.options = subgroup.options.map(o =>
      Object.assign(o, { checked: false })
    );
    option.checked = true;
  }

  addQuantity(option) {
    if (option.selectedValue + 1 <= option.max) {
      option.selectedValue++;
    }
  }

  subtractQuantity(option) {
    if (option.selectedValue - 1 >= option.min) {
      option.selectedValue--;
    }
  }

  changeQuantity(event, option) {
    const v = parseInt(event.target.value, 10);
    if (v >= option.min && v <= option.max) {
      option.selectedValue = v;
    }
  }

  isAnyChecked(options: Option[]) {
    let checked = false;
    options.forEach(option => {
      if (option.checked) {
        checked = true;
      }
    });

    return checked;
  }

  changeQuantitySelect(event, option) {
    let selectedRange = null;
    for (const range in option.range) {
      if(option.range[range] == event.target.value){
        selectedRange = range;
        break;
      }
    }
    option.selectedValue = selectedRange;
  }

  changeCheckbox(option) {
    option.checked = !option.checked;
  }

  shouldShowRange(option: Option) {
    return !isNaN(option.min)
      && !isNaN(option.max)
      && option.type === 'range'
      && (option.min !== option.max)
      && (option.min < option.max);
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/group-box.component.ts